const INTENT_LABEL_MAP: Record<string, string> = {
    device_activation: "DEVICE ACTIVATION",
    insurance_and_claims: "INSURANCE AND CLAIMS",
    connectivity_and_network: "CONNECTIVITY AND NETWORK",
    software_hardware_troubleshooting: "SOFTWARE/HARDWARE TROUBLESHOOTING",
    carrier_account_management: "CARRIER ACCOUNT MANAGEMENT",
    bills_and_payment: "BILLS AND PAYMENTS",
    storage_and_content_management: "STORAGE AND CONTENT MANAGEMENT",
    security_and_privacy: "SECURITY AND PRIVACY",
    battery: "BATTERY",
    other: "OTHER",
    return: "RETURN",
    asked_to_agent: "ASKED TO AGENT",
    unknown: "UNKNOWN",
};

export function getMappedIntent(intent: string): string | undefined {
    if (intent === "out_of_scope") return undefined;
    return INTENT_LABEL_MAP[intent] ?? intent;
}
